<template>
    <modal ref="modal" @hidden="$emit('hidden')" :size="size" :options="{ close: { onBlur: false, onEsc: false } }">
        
        <template v-slot:modal-title>
            <h3>{{title}} {{resource('JourneyComposer_BrickSettingsBase_Title')}}</h3>
        </template>

        <template v-slot:modal-body>
            <div class="row mb-2">
                <div class="col-4">
                    <label :for="fieldName">{{fieldName}}</label>
                </div>
                <div class="col-8">
                    <input-group icon="far fa-edit">
                        <input :id="fieldName" :name="fieldName" type="text" class="form-control" :disabled="!canWrite" v-model="newName" />
                    </input-group>
                    
                    <required v-if="showError" :fieldName="fieldName"/>
                </div>
            </div>
            <slot></slot>
        </template>

        <template v-slot:modal-footer>
            <settings-controls
                :disableSave="showError"
                :prompt="promptValues"
                @save="handleSave"
                @cancel="$refs.modal.hide()"
                @delete="handleDelete"
            />
        </template>

    </modal>
</template>

<script>

//resources
import resources from '../../../../../Util/Mixins/resources';

//Components
import Modal,{sizes} from '../../../../../Components/Util/Modal.vue';
import InputGroup from '../../../../../Components/Inputs/InputGroup.vue';
import RequiredErrorMessage from '../../../../../Components/Errors/RequiredErrorMessage.vue';
import SettingsControls from '../../SettingsControls.vue';

export default {
    name: 'journey-brick-settings-base',
    mixins: [resources],
    components: {
        Modal,
        SettingsControls,
        InputGroup,
        'required': RequiredErrorMessage
    },
    // created() {
    //     this.newName = this.value;
    // },
    mounted() {
        this.$refs.modal.show();
    },
    methods: {
        handleSave() {
            this.$emit('save');
            this.$refs.modal.hide();
        },
        handleDelete() {
            this.$emit('delete');
            this.$refs.modal.hide();
        }
    },
    data() {
        return {
            showError: false,
            fieldName:  this.resource('JourneyComposer_BrickSettingsBase_Name_DisplayName')
        };
    },
    computed: {
        promptValues() {
            return this.prompt || {
                title: this.resource('JourneyBuilder_GenericSettings_Delete_Title'),
                body: this.resource('JourneyBuilder_GenericSettings_Delete_Body')
            }
        },
        newName: {
            get(){
                return this.value;
            },
            set(value){
                this.$emit('input', value);
            }
        }
    },
    watch: {
        value(value) {
            // if(value != this.value) {
            //     this.$emit('input', value);
            // }

            if(value === '') {
                this.showError = true;
            } else {
                this.showError = false;
            }
        }
    },
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: String,
            default: ''
        },
        canWrite: {
            type: Boolean,
            default: false
        },
        prompt: {
            type: Object,
            default: null
        },
        size: {
            type: String,
            default: sizes.medium,
            validator: (value) => {
                return Object.values(sizes).indexOf(value) !== -1
            }
        }
    }
};
</script>

<style lang="scss" scoped>

</style>